import { Button, Popup, Tab, Tabs } from "vant";
import { ref } from "vue";
import PostMetfoneService from "@/components/post-metfone-service";
import DataNotify from "@/components/data-notify"; 
import packageOfData from "@/mocks/packageOfData";
import InfiniteLoading from "v3-infinite-loading";
import "v3-infinite-loading/lib/style.css";
import { mapState } from "vuex";
import jsonfile from "jsonfile";
import { version } from "@/../package.json";
import { CONSTANTS } from "@/helpers/constants";
import MetfoneLoading from "@/components/metfone-loading.vue";
export default {
  name: "History",
  components: {
    MetfoneLoading,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Popup.name]: Popup,
    [Button.name]: Button,
    PostMetfoneService,
    DataNotify, 
    InfiniteLoading,
  },
  setup() {
    const activeName = ref("myServices");
    return { activeName };
  },
  data() {
    return {
      data: packageOfData,
      checked: false,
      listHistory: [],
      myServices: [],
      page: 1,
      pageSize: 10,
      pageMyService: 1,
      pageSizeMyService: 10,
      finished: false,
      infiniteId: 1,
      versionCode: "1.0.0",
      loadingMyService: false,
      loadingHistories: false,
      showCenter: false,
      imageUrl: "img/header-modal-detail-package.png",
      detailModel: {
        name: null,
        fullDes: null,
        type: null,
      },
      loadingDetail: false,
    };
  },
  created() {
    // this.checkPlatform();
    // this.getListHistory();
    this.getListMyService();
    this.versionCode = version;
  },
  computed: {
    ...mapState("userStore", ["profile", "defaultParam"]),
    getfullName() {
      if (this.profile) {
        let fullName = "";
        if (this.profile.firstName) {
          fullName = `${this.profile.firstName} `;
        }
        if (this.profile.middleName) {
          fullName += `${this.profile.firstName} `;
        }
        if (this.profile.lastName) {
          fullName += `${this.profile.lastName}`;
        }
        return fullName;
      }

      return "";
    },
  },
  watch: {
    "$route.hash": {
      handler: function (dialog_id) {
        if (dialog_id !== "#dialogStockChooser") {
          this.checked = false;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // this.getListHistory();
  },
  methods: {
    color_primary() {
      return CONSTANTS.color_primary;
    },
    async handleShowDetailPackage(isShow, value) {
      if (isShow) {
        if (!value) return;
        // TODO:
        let params = this.stateAsObject(this.defaultParam);
        params.accountId = this.profile ? this.profile.appId : "";
        params.phoneNumber = value.phoneNumber;
        params.subServiceCode = value.subServiceCode;

        // TODO: Remove when build
        // params.accountId = "988216";
        this.$store.dispatch("loadingStore/showLoading", { status: true });
        await this.$store
          .dispatch("metfoneStore/getCurrentUsedServiceDetail", params)
          .then((res) => {
            if (res) {
              let result = res.data;
              if (result && result.errorCode == 0) {
                let services = result.services;
                if (services.length > 0) {
                  this.detailModel.name = services[0].subServiceName;
                  this.detailModel.fullDes = services[0].fullDes;

                  this.detailModel.type = "myservice";
                  this.showCenter = isShow;
                }
              }
            }
          });
      } else {
        this.detailModel = {
          name: null,
          fullDes: null,
          type: null,
        };
        this.showCenter = isShow;
      }
      this.$store.dispatch("loadingStore/showLoading", { status: false });
    },
    handleShowDetailPackageHistory(isShow, value) {
      if (isShow) {
        if (!value) return;
        // TODO:
        this.detailModel.name = value.subServiceName;
        this.detailModel.fullDes = value.fullDes;
        this.detailModel.type = "history";
      } else {
        this.detailModel = {
          name: null,
          fullDes: null,
          type: null,
        };
      }
      this.showCenter = isShow;
    },
    checkPlatform() {
      const isAndroidWebView =
        navigator.userAgent.toLowerCase().indexOf("android") > -1;

      // Check if the user agent contains "iPhone" or "iPad" to determine if it's an iOS WebView
      const isiOSWebView = /(iPhone|iPod|iPad)/i.test(navigator.userAgent);

      if (isAndroidWebView) {
        let parentElement = document.getElementById("parentElement1");
        if (parentElement) {
          let childElements =
            parentElement.getElementsByClassName("van-tabs__wrap");
          if (childElements.length > 0) {
            const element = childElements[0];
            // element.style.top = '96px';

            const myDiv = document.getElementById("icon-history");
            const divHeight = myDiv.offsetHeight;
            element.style.top = "32" + "px";
          }
        }

        // let iconHistory = document.getElementById("icon-history");
        // if(iconHistory){
        //     iconHistory.style.top = "64px";
        // }
        return 1;
      } else if (isiOSWebView) {
        let parentElement = document.getElementById("parentElement1");
        if (parentElement) {
          let childElements =
            parentElement.getElementsByClassName("van-tabs__wrap");
          if (childElements.length > 0) {
            const element = childElements[0];
            const myDiv = document.getElementById("icon-history");
            const divHeight = myDiv.offsetHeight;
            // element.style.top = divHeight + 'px';
            element.style.top = "32" + "px";
          }
        }
        return 2;
      } else {
        let parentElement = document.getElementById("parentElement");
        if (parentElement) {
          let childElements =
            parentElement.getElementsByClassName("van-tabs__wrap");
          if (childElements.length > 0) {
            const element = childElements[0];
            // element.style.top = '96px';
            const myDiv = document.getElementById("icon-history");
            const divHeight = myDiv.offsetHeight;
            // element.style.top = divHeight + 'px';
            // element.style.top = '60px';
            element.style.top = "32" + "px";
          }
        }
        // let iconHistory = document.getElementById("icon-history");
        // if(iconHistory){
        //     iconHistory.style.top = "64px";
        // }
        return 0;
      }
    },
    checkArray(array) {
      if (Array.isArray(array)) {
        return true;
      } else return false;
    },
    handleIsShowConfirm() {
      this.$store.dispatch("modalStore/changeModal", true);
      this.checked = true;
      this.$router.push("#dialogStockChooser");
    },
    async getListHistory($state) {
      // $state.loaded();
      let defaultParam = this.stateAsObject(this.defaultParam);
      // let defaultParam = {
      //     locale : "kh_KH",
      //     msisdn: "855315445204",
      //     token: CONSTANTS.TOKEN,
      // }

      // TODO: Remove when build
      // defaultParam.msisdn =  "988216";

      defaultParam.pageSize = this.pageSize;
      defaultParam.pageNumber = this.page;
      let params = defaultParam;
      if (this.profile) {
        // let tempPhone = this.profile.phone.replace(/\D/g, "");
        // params.msisdn = tempPhone;
        params.msisdn = this.profile.appId;
      }
      await this.$store
        .dispatch("metfoneStore/getListHistory", params)
        .then((res) => {
          if (res) {
            let result = res.data;
            if (result && result.errorCode == 0) {
              if (
                result.services.length &&
                result.services.length <= this.pageSize
              ) {
                const anotherArray = [...result.services];
                this.listHistory.push(...anotherArray);
                this.page += 1;
                // $state.loaded();
              } else {
                $state.complete();
              }
              const histories = result.services;
              if (this.checkArray(histories)) {
                histories.map((value, index) => {
                  if (this.isObjectEmpty(value)) {
                    this.listHistory = [];
                    return;
                  }
                });
              }
            }
          }
        });
      setTimeout(() => {
        this.loadingHistories = true;
      }, 300);
    },
    isObjectEmpty(obj) {
      if (obj) return Object.entries(obj).length === 0;
      return true;
    },
    stateAsObject(value) {
      return JSON.parse(JSON.stringify(value));
    },
    async getListMyService() {
      this.loadingMyService = false;
      let defaultParam = this.stateAsObject(this.defaultParam);
      let params = defaultParam;
      if (this.profile) {
        // let tempPhone = this.profile.phone.replace(/\D/g, "");
        // params.msisdn = tempPhone;
        params.msisdn = this.profile.appId;
      }

      // TODO: Remove when build
      // params.msisdn =  "988216";
      await this.$store
        .dispatch("metfoneStore/getListMyService", params)
        .then((res) => {
          if (res) {
            let result = res.data;
            if (result && result.errorCode == 0) {
              this.myServices = result.services;

              const myServices = result.services;
              if (this.checkArray(myServices)) {
                myServices.map((value, index) => {
                  if (this.isObjectEmpty(value)) {
                    this.myServices = [];

                    return;
                  }
                });
              }
              setTimeout(() => {
                this.loadingMyService = true;
              }, 300);
            }
          }
        });
      this.loadingMyService = true;
    },

    // TODO: not using
    async getListMyService2($state) {
      let defaultParam = this.stateAsObject(this.defaultParam);
      let params = defaultParam;
      if (this.profile) {
        let tempPhone = this.profile.phone.replace(/\D/g, "");
        // params.msisdn = tempPhone;
        params.msisdn = this.profile.appId;
      }
      defaultParam.pageSize = this.pageSizeMyService;
      defaultParam.pageNumber = this.pageMyService;
      await this.$store
        .dispatch("metfoneStore/getListMyService", params)
        .then((res) => {
          if (res) {
            let result = res.data;
            if (result && result.errorCode == 0) {
              if (
                result.services.length &&
                result.services.length <= this.pageSizeMyService
              ) {
                const anotherArray = [...result.services];
                this.myServices.push(...anotherArray);
                this.pageMyService += 1;
                $state.loaded();
              } else {
                $state.complete();
              }
              const myServices = result.services;
              if (this.checkArray(myServices)) {
                myServices.map((value, index) => {
                  if (this.isObjectEmpty(value)) {
                    this.myServices = [];
                    return;
                  }
                });
              }
            }
          }
        });
    },
  },
};
